module.exports = "<div id=\"compareTable{{widgetId}}\"></div>"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/compare-table/compare-table.component.html
// module id = ../../../../../src/app/shared/components/graphs/compare-table/compare-table.component.html
// module chunks = main